import React, { useState } from "react";
import { FullWidthTabs } from "components";
import { PageContainer } from "shared";
import AdvertPopup from "./AdvertPopup";

const tabList = [
  {
    label: "Esetech",
    Icon: "Web",
    platform: "esetech",
    Comp: AdvertPopup,
  },
  {
    label: "Kaapo",
    Icon: "Web",
    platform: "kaapo",
    Comp: AdvertPopup,
  },
];

export default function Index() {
  const [currentTab, setCurrentTab] = useState(tabList[0]);

  return (
    <PageContainer>
      <FullWidthTabs
        {...{ currentTab, setCurrentTab, tabList }}
        Comp={<currentTab.Comp {...currentTab} />}
      />
    </PageContainer>
  );
}
